export class AuthError extends Error {
  readonly reason:
    | "state"
    | "nonce"
    | "missingCode"
    | "loginRequired"
    | "exchange"
    | "credentials"
    | "passwordReset"
    | "network"
    | "challenge"
    | "config"
    | "passkey"
    | "google";
  readonly returnTo: string | null;
  readonly code: string | null;

  constructor(
    reason: AuthError["reason"],
    message: string,
    returnTo: string | null = null,
    code: string | null = null,
  ) {
    super(message);
    this.name = "AuthError";
    this.reason = reason;
    this.returnTo = returnTo;
    this.code = code;
  }
}
